(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loomies-christmas-game"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('loomies-christmas-game'))customElements.define('loomies-christmas-game',class extends HTMLElement{
  connectedCallback(){
    if(this.started)return;this.started=true;this.strings=JSON.parse(this.querySelector('[data-lmx-translations]').textContent);this.dialog=this.querySelector('dialog');this.root=window.Shopify?.routes?.root||'/';this.abort=new AbortController();
    this.querySelector('[data-close]').onclick=()=>this.close();this.querySelector('[data-shop]').onclick=()=>this.close();
    this.dialog.addEventListener('cancel',e=>{e.preventDefault();this.close();});
    document.addEventListener('visitorConsentCollected',()=>this.boot(),{signal:this.abort.signal});
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.status();},{signal:this.abort.signal});
    window.addEventListener('pageshow',()=>this.status(),{signal:this.abort.signal});
    this.channel=typeof BroadcastChannel==='function'?new BroadcastChannel('loomies-game'):null;
    if(this.channel)this.channel.onmessage=()=>this.status();
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsub=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{if(this.state?.reward)this.syncCart().catch(()=>this.cartError());});
    if(window.Shopify?.customerPrivacy)this.boot();
    else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)this.boot();});
  }
  allowed(){return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.()===true;}
  async boot(){
    if(!this.allowed()){this.state=null;this.dialog.close();this.paint();return;}
    if(this.timer)return;
    try{localStorage.setItem('lmx-check','1');localStorage.removeItem('lmx-check');}catch{return;}
    if(!navigator.locks)return;
    await this.status();
    this.timer=setInterval(()=>{this.paint();if(!document.hidden&&performance.now()-(this.lastPoll||0)>30000)this.status();this.maybeShow();},1000);
  }
  async api(action,extra={}){
    if(!this.allowed())throw new Error('CONSENT');
    const response=await fetch(this.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action,theme:this.dataset.theme,token:localStorage.getItem('lmx-token'),...extra}),signal:AbortSignal.timeout(10000)});
    if(!response.ok)throw new Error('SERVICE');const data=await response.json();
    if(!Number.isFinite(data.serverNow)||!data.visit)throw new Error('RESPONSE');
    localStorage.setItem('lmx-token',data.token);this.anchor={server:data.serverNow,local:performance.now()};this.state=data;this.lastPoll=performance.now();return data;
  }
  now(){return this.anchor?this.anchor.server+performance.now()-this.anchor.local:Infinity;}
  async status(){
    if(!this.allowed()||!navigator.locks||this.polling)return;this.polling=true;
    try{await navigator.locks.request('lmx-identity',()=>this.api('status'));if(this.state.reward)await this.syncCart();else await this.clearExpired();this.paint();}
    catch{this.state=null;this.paint();}finally{this.polling=false;}
  }
  async maybeShow(){
    if(!this.allowed()||!this.state||document.hidden||this.dialog.open||this.state.reward||this.state.played||this.now()<this.state.eligibleAt||document.querySelector('cart-drawer.active'))return;
    await navigator.locks.request('lmx-popup',()=>{
      if(localStorage.getItem('lmx-seen')===this.state.visit)return;
      localStorage.setItem('lmx-seen',this.state.visit);this.querySelector('[data-question]').textContent=/Rovaniemi|Weihnachtsmann/.test(this.state.question)?this.strings.question:this.state.question;
      this.querySelector('[data-feedback]').textContent='';this.querySelector('[data-clock]').textContent='';this.querySelector('[data-shop]').hidden=true;
      const answers=this.querySelector('[data-answers]');answers.replaceChildren();
      this.state.answers.forEach((label,index)=>{const button=document.createElement('button');button.type='button';button.textContent=({Finnland:this.strings.finland,Schweiz:this.strings.switzerland,Australien:this.strings.australia})[label]||label;button.onclick=()=>this.answer(index);answers.append(button);});
      this.dialog.showModal();
    });
  }
  async answer(answer){
    this.querySelectorAll('[data-answers] button').forEach(b=>b.disabled=true);
    try{await this.api('answer',{visit:this.state.visit,answer});this.channel?.postMessage('change');
      if(this.state.reward){await this.syncCart();this.querySelector('[data-feedback]').textContent=this.applied?this.strings.active:this.strings.won;}
      else this.querySelector('[data-feedback]').textContent=this.state.unavailable?this.strings.unavailable:this.strings.wrong;
    }catch{this.querySelector('[data-feedback]').textContent=this.strings.error;}
    this.querySelector('[data-shop]').hidden=false;this.paint();
  }
  close(){this.dialog.close();if(this.state&&!this.state.played)this.api('dismiss',{visit:this.state.visit}).then(()=>this.channel?.postMessage('change')).catch(()=>{});}
  async cartRequest(body){const r=await fetch(this.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...body,sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});if(!r.ok)throw new Error('CART');return r.json();}
  codes(cart){if(!Array.isArray(cart.discount_codes))throw new Error('CODES');return cart.discount_codes.map(d=>d.code);}
  async syncCart(){
    if(this.cartBusy||!this.state?.reward||this.now()>=this.state.reward.expiresAt)return;this.cartBusy=true;
    try{await navigator.locks.request('lmx-cart',async()=>{
      const r=await fetch(this.root+'cart.js',{cache:'no-store'});if(!r.ok)throw new Error('CART');let cart=await r.json(),reward=this.state.reward;
      if(!reward||this.now()>=reward.expiresAt)return;
      const codes=this.codes(cart),previous=localStorage.getItem('lmx-code');
      if(!codes.includes(reward.code)){cart=await this.cartRequest({discount:[...codes.filter(c=>c!==previous),reward.code].join(',')});this.renderCart(cart);}
      localStorage.setItem('lmx-code',reward.code);localStorage.setItem('lmx-expiry',String(reward.expiresAt));
      this.applied=cart.discount_codes?.some(d=>d.code===reward.code&&d.applicable)===true;
    });}finally{this.cartBusy=false;}
  }
  async clearExpired(){
    const code=localStorage.getItem('lmx-code'),expiry=Number(localStorage.getItem('lmx-expiry'));
    if(!code||!expiry||this.now()<expiry||this.cartBusy)return;this.cartBusy=true;
    try{await navigator.locks.request('lmx-cart',async()=>{
      const r=await fetch(this.root+'cart.js',{cache:'no-store'});if(!r.ok)throw new Error('CART');const cart=await r.json(),codes=this.codes(cart);
      const updated=await this.cartRequest({discount:codes.filter(c=>c!==code).join(',')});this.renderCart(updated);
      localStorage.removeItem('lmx-code');localStorage.removeItem('lmx-expiry');this.applied=false;
    });}finally{this.cartBusy=false;}
  }
  renderCart(cart){
    const drawer=document.querySelector('cart-drawer'),active=document.activeElement?.id;
    if(!drawer||!cart.sections?.['cart-drawer'])return;
    const parsed=new DOMParser().parseFromString(cart.sections['cart-drawer'],'text/html'),next=parsed.querySelector('#CartDrawer');
    if(!next)throw new Error('SECTION');
    drawer.querySelector('#CartDrawer').innerHTML=next.innerHTML;drawer.classList.toggle('is-empty',!cart.item_count);
    drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close());
    if(drawer.classList.contains('active')&&typeof trapFocus==='function')trapFocus(drawer.querySelector('.drawer__inner'),document.getElementById(active)||drawer.querySelector('.drawer__close'));
    const bubble=cart.sections['cart-icon-bubble'];if(bubble){const doc=new DOMParser().parseFromString(bubble,'text/html');const target=document.getElementById('cart-icon-bubble');if(target)target.innerHTML=doc.querySelector('.shopify-section')?.innerHTML||target.innerHTML;}
  }
  cartError(){this.applied=false;this.paint();}
  paint(){
    const reward=this.allowed()?this.state?.reward:null,remaining=reward?Math.max(0,Math.ceil((reward.expiresAt-this.now())/1000)):0;
    const clock=remaining?Math.floor(remaining/60)+':'+String(remaining%60).padStart(2,'0'):'';
    this.querySelector('[data-clock]').textContent=clock;
    for(const target of [document.querySelector('product-form'),document.querySelector('.drawer__footer')]){
      if(!target)continue;let banner=target.querySelector('.lmx-banner');
      if(!remaining){banner?.remove();continue;}
      if(!banner){banner=document.createElement('div');banner.className='lmx-banner';target.prepend(banner);}
      const label=this.applied?this.strings.active_label:this.strings.won_label;
      banner.replaceChildren(document.createTextNode(label));const strong=document.createElement('strong');strong.textContent=clock;banner.append(strong);
    }
    if(reward&&!remaining){this.state.reward=null;this.querySelector('[data-feedback]').textContent=this.strings.expired;this.clearExpired().catch(()=>this.cartError());}
  }
  disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.channel?.close();this.unsub?.();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loomies-header"]) return;
  try {
    
document.addEventListener('click', event => {const menu=document.querySelector('.lm-mobile-menu');if(menu&&(event.target.closest('.lm-mobile-menu a')||!menu.contains(event.target)))menu.open=false;});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.lm-mobile-menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loomies-landing"] && !Shopify.designMode) return;
  try {
    
function initLoomiesProduct(scope=document){
 scope.querySelectorAll('[data-lm-product]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const gallery=root.querySelector('[data-lm-gallery]'),track=gallery.querySelector('[data-lm-track]'),thumbs=[...gallery.querySelectorAll('[data-lm-thumb]')];
  let active=0;const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  function select(index){active=Math.max(0,Math.min(index,track.children.length-1));track.scrollTo({left:track.clientWidth*active,behavior:reduced.matches?'instant':'smooth'});}
  function sync(){if(!track.clientWidth)return;active=Math.round(track.scrollLeft/track.clientWidth);const count=gallery.querySelector('[data-lm-count]');if(count)count.textContent=String(active+1);thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));const thumb=thumbs[active];if(thumb){const strip=thumb.parentElement;if(thumb.offsetLeft<strip.scrollLeft||thumb.offsetLeft+thumb.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollTo({left:thumb.offsetLeft-strip.clientWidth/2+thumb.offsetWidth/2,behavior:'instant'});}}
  thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>select(i)));
  gallery.querySelector('[data-lm-prev]')?.addEventListener('click',()=>select(active-1));gallery.querySelector('[data-lm-next]')?.addEventListener('click',()=>select(active+1));
  track.addEventListener('scroll',sync,{passive:true});track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();select(active+(event.key==='ArrowRight'?1:-1));}});
  root.querySelectorAll('input[name="quantity"]').forEach(input=>input.addEventListener('change',()=>{const price=root.querySelector('[data-lm-sticky-price]');if(price)price.textContent=input.dataset.lmTotal;}));
  const sticky=root.querySelector('[data-lm-sticky]'),buyForm=root.querySelector('.lm-buy-form');
  if(sticky&&buyForm){const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.bottom>0;});observer.observe(buyForm);root._loomiesObserver=observer;}
 });
}
initLoomiesProduct();document.addEventListener('shopify:section:load',event=>initLoomiesProduct(event.target));document.addEventListener('shopify:section:unload',event=>event.target.querySelector('[data-lm-product]')?._loomiesObserver?.disconnect());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loomies-order-tracking"]) return;
  try {
    
function loomiesLoadTrack123(){
 const host=document.querySelector('track123-tracking-widget');if(!host)return;
 const notice=document.querySelector('.lmt-track123-loading');
 if(customElements.get('track123-tracking-widget')){if(notice)notice.hidden=true;return;}
 let script=document.getElementById('loomies-track123-script');
 if(!script){script=document.createElement('script');script.id='loomies-track123-script';script.src='https://shp.track123.com/tracking-page/build/widget.min.js';script.async=true;script.addEventListener('error',()=>{if(notice)notice.textContent=notice.dataset.error;});document.head.append(script);}
 customElements.whenDefined('track123-tracking-widget').then(()=>{if(notice)notice.hidden=true;});
}
loomiesLoadTrack123();
document.addEventListener('shopify:section:load',loomiesLoadTrack123);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loomies-product-v3"] && !Shopify.designMode) return;
  try {
    
function initLoomiesProductV3(scope=document){
 scope.querySelectorAll('[data-lp-product]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const gallery=root.querySelector('[data-lp-gallery]'),track=gallery.querySelector('[data-lp-track]'),thumbs=[...gallery.querySelectorAll('[data-lp-thumb]')];
  let active=0;const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  function select(index){active=Math.max(0,Math.min(index,track.children.length-1));track.scrollTo({left:track.clientWidth*active,behavior:reduced.matches?'instant':'smooth'});}
  function sync(){if(!track.clientWidth)return;active=Math.round(track.scrollLeft/track.clientWidth);const count=gallery.querySelector('[data-lp-count]');if(count)count.textContent=String(active+1);thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));const thumb=thumbs[active];if(thumb){const strip=thumb.parentElement;if(thumb.offsetLeft<strip.scrollLeft||thumb.offsetLeft+thumb.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollTo({left:thumb.offsetLeft-strip.clientWidth/2+thumb.offsetWidth/2,behavior:'instant'});}}
  thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>select(i)));
  gallery.querySelector('[data-lp-prev]')?.addEventListener('click',()=>select(active-1));gallery.querySelector('[data-lp-next]')?.addEventListener('click',()=>select(active+1));
  track.addEventListener('scroll',sync,{passive:true});track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();select(active+(event.key==='ArrowRight'?1:-1));}});
  root.querySelectorAll('input[name="quantity"]').forEach(input=>input.addEventListener('change',()=>{const price=root.querySelector('[data-lp-sticky-price]');if(price)price.textContent=input.dataset.lpTotal;}));
  const sticky=root.querySelector('[data-lp-sticky]'),buyForm=root.querySelector('.lp-buy-form');
  if(sticky&&buyForm){const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.bottom>0;});observer.observe(buyForm);root._loomiesObserver=observer;}
 });
}
initLoomiesProductV3();document.addEventListener('shopify:section:load',event=>initLoomiesProductV3(event.target));document.addEventListener('shopify:section:unload',event=>event.target.querySelector('[data-lp-product]')?._loomiesObserver?.disconnect());

  } catch(e) { console.error(e); }
})();
})();
